module.exports = __webpack_public_path__ + "img/Manuel Gonzalez Alzuru.1be357df.jpg";